var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntuitiveExperiences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5555 54.9998L42.8395 48.8887L36.1729 45.9875L42.8395 43.0863L45.5555 36.6665L48.3333 43.0863L55 45.9875L48.3333 48.8887L45.5555 54.9998Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5555 18.2716L42.8395 11.9136L36.1729 8.95062L42.8395 6.04938L45.5555 0L48.3333 6.04938L55 8.95062L48.3333 11.9136L45.5555 18.2716Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5185 45.6174L12.716 33.1482L0 27.4692L12.716 21.7902L18.5185 9.38281L24.3827 21.7902L37.037 27.4692L24.3827 33.1482L18.5185 45.6174Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntuitiveExperiences);
export default __webpack_public_path__ + "static/media/intuitive-experiences.ae765cb3e59912540688737e4a839c2a.svg";
export { ForwardRef as ReactComponent };